import { createEventScheduleModel } from '@/modules/schedule/domain/models/CreateEventScheduleModel'

import { axios, Response } from '../index'
import { SchedulePeriod } from './get-schedule-for-period'

export const createEventSchedule = (
  body: createEventScheduleModel
): Response<SchedulePeriod> => {
  return axios.post(`/v1/sessions`, body)
}
